import { Dialog } from '@progress/kendo-react-dialogs';
import { EquipmentListContext } from 'app/components/ReactContexts/equipmentListContext';
import {
  ic_nav_back as BackIcon,
  ic_nav_close as CloseIcon,
} from 'app/widgets/SVGs';
import SuccessIcon from 'assets/images/ill_success.svg';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { tagEvent } from 'utils/ga';
import { UpdateHoursCard } from './UpdateHoursCard';

interface IUpdateHoursProps {
  updateIsUpdateHoursExpanded: (updatedIsUpdateHoursExpanded: boolean) => void;
}

export function UpdateHours(props: IUpdateHoursProps) {
  const { t } = useTranslation();
  const { equipmentListData, setEquipmentListData } =
    React.useContext(EquipmentListContext);

  const nonTelematicsEquipment = React.useMemo(() => {
    return (
      equipmentListData.equipmentList?.filter(
        item => item.hasTelematics == false && !item.updated,
      ) || []
    );
  }, [equipmentListData.equipmentList]);

  const hasAnyEquipment = !!nonTelematicsEquipment.length;

  const updateHours = async (equipmentId, newValue) => {
    try {
      let selectedEquipment = equipmentListData.selectedEquipment;
      let newDate = new Date().toISOString();
      if (
        selectedEquipment &&
        equipmentId === equipmentListData.selectedEquipment?.id
      ) {
        selectedEquipment.userEnteredEngineHours = newValue;
        selectedEquipment.dateModified = newDate;
      }

      setEquipmentListData(oldData => ({
        ...oldData,
        equipmentList: oldData.equipmentList!.map(equip => {
          if (equipmentId === equip.id) {
            return {
              ...equip,
              userEnteredEngineHours: Number(newValue),
              dateModified: newDate,
              updated: true,
            };
          }
          return equip;
        }),
        selectedEquipment: selectedEquipment,
      }));

      tagEvent('edit_engine_hours');
      return { success: true };
    } catch (error) {
      return { error: error as string };
    }
  };

  return (
    <>
      <Dialog className="modal-equipment modal-fixed-button modal-equipment-hours">
        <div className="row height-100">
          <div className="col-sm-12">
            <div className="modal-container relative">
              <span
                className={`back-button fixed-on-desktop ${
                  hasAnyEquipment ? '' : 'close-button'
                }`}
                onClick={() => props.updateIsUpdateHoursExpanded(false)}
              >
                {hasAnyEquipment ? <BackIcon /> : <CloseIcon />}
              </span>
              <h2>{t('edit_equipment_hours')}</h2>
              <div className="subtitle-caption">
                <span>{t('edit_equipment_hours_description')}</span>
              </div>
              {hasAnyEquipment ? (
                <>
                  <div>
                    <span style={{ fontWeight: 600 }}>
                      {nonTelematicsEquipment.length}
                    </span>{' '}
                    {t('edit_equipment_hours_count')}
                  </div>
                  <div>
                    {nonTelematicsEquipment.map(nonTelEq => {
                      if (!nonTelEq.updated)
                        return (
                          <UpdateHoursCard
                            key={nonTelEq.id}
                            equipment={nonTelEq}
                            updateHoursFc={updateHours}
                          />
                        );
                      return null;
                    })}
                  </div>
                </>
              ) : (
                <div className="height-100 equipment-hours-done">
                  <div className="success-image-container">
                    <img className="success-image" src={SuccessIcon} alt="" />
                  </div>
                  <h4>{t('all_equipment_updated')}</h4>
                  <div>{t('edit_equipment_hours_notify')}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
